import { $4 } from 'global';

class TymRail extends HTMLElement {
  connectedCallback() {
    this.track = $4('[data-rail-track]', this);
    if (!this.track) return;

    this.prev = $4('[data-rail-prev]', this);
    this.next = $4('[data-rail-next]', this);

    this.abortController = new AbortController();
    const { signal } = this.abortController;

    if (this.prev) this.prev.addEventListener('click', () => this.step(-1), { signal });
    if (this.next) this.next.addEventListener('click', () => this.step(1), { signal });
    this.track.addEventListener('scroll', () => this.sync(), { signal, passive: true });

    if (window.ResizeObserver) {
      this.observer = new ResizeObserver(() => this.sync());
      this.observer.observe(this.track);
    }

    this.sync();
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.observer?.disconnect();
  }

  get amount() {
    const item = this.track.firstElementChild;
    if (!item) return this.track.clientWidth;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    return item.getBoundingClientRect().width + gap;
  }

  step(direction) {
    const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.track.scrollBy({ left: this.amount * direction, behavior: smooth ? 'smooth' : 'auto' });
  }

  sync() {
    const max = this.track.scrollWidth - this.track.clientWidth;
    this.toggleAttribute('no-overflow', max <= 2);
    if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
    if (this.next) this.next.disabled = this.track.scrollLeft >= max - 2;
  }
}

if (!customElements.get('tym-rail')) {
  customElements.define('tym-rail', TymRail);
}
